import { BRANCH_W, INK_SOFT } from '../timelineDiagramGeometry'
import { type ForkPlanPlacement } from '../timelineDiagramLayout'
import { ARROWHEAD_MARKER_URL } from './ArrowheadMarker'

// The alternate plans (S above, B/C/D below) curving off the rounded left trunk.
// Each arm runs out past its label to an arrowhead — its own timeline branching
// away from Plan A. Positions come from PLACEMENT.
export const ForkBranches = ({
  trunk,
  forkPlans,
}: {
  trunk: string
  forkPlans: ForkPlanPlacement[]
}) => (
  <>
    <path d={trunk} stroke={INK_SOFT} strokeWidth={BRANCH_W} />
    {forkPlans.map(plan => (
      <path
        key={plan.planId}
        d={plan.arm}
        stroke={INK_SOFT}
        strokeWidth={BRANCH_W}
        markerEnd={ARROWHEAD_MARKER_URL}
      />
    ))}
  </>
)
